// extracted by mini-css-extract-plugin
export default {"dashboardGrid":"DashboardGrid_dashboardGrid__geCkM","resizable":"DashboardGrid_resizable__SJr-u","gridItemWrapper":"DashboardGrid_gridItemWrapper__Zyk3o"};